import React, { useState } from 'react';
import {
  Box,
  Drawer,
  AppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Button,
  Menu,
  MenuItem,
  Avatar,
  useTheme,
  useMediaQuery
} from '@mui/material';
// ✅ ИСПРАВЛЕНО (2026-01-11): Прямые импорты MUI иконок для корректной работы webpack chunks
import MenuIcon from '@mui/icons-material/Menu';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import SettingsIcon from '@mui/icons-material/Settings';
import AccountIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import FolderIcon from '@mui/icons-material/Folder';
import MessageIcon from '@mui/icons-material/Message';
import InputFlowIcon from '@mui/icons-material/Input';
import ArticleIcon from '@mui/icons-material/Article';
import PersonIcon from '@mui/icons-material/Person';
import ApiIcon from '@mui/icons-material/Api';
import MovieIcon from '@mui/icons-material/Movie';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import TimelineIcon from '@mui/icons-material/Timeline';
import CalculateIcon from '@mui/icons-material/Calculate';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import BusinessIcon from '@mui/icons-material/Business';
import BuildIcon from '@mui/icons-material/Build';
import CloudIcon from '@mui/icons-material/Cloud';
import BackupIcon from '@mui/icons-material/Backup';
import WebIcon from '@mui/icons-material/Language';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import DescriptionIcon from '@mui/icons-material/Description';
import GavelIcon from '@mui/icons-material/Gavel';
import HandshakeIcon from '@mui/icons-material/Handshake';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
// MenuManagementIcon - alias for MenuIcon for menu management page
const MenuManagementIcon = MenuIcon;

const drawerWidth = 240;

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, user } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const menuItems = [
    {
      text: 'Dashboard',
      icon: <DashboardIcon />,
      path: '/dashboard'
    },
    {
      text: 'Menu Management',
      icon: <MenuManagementIcon />,
      path: '/menu'
    },
    {
      text: 'Bot Messages',
      icon: <MessageIcon />,
      path: '/bot-messages'
    },
    {
      text: 'Context Messages & Flows',
      icon: <MessageIcon />,
      path: '/context-messages'
    },
    {
      text: 'Reference Materials',
      icon: <ArticleIcon />,
      path: '/reference-materials'
    },
    {
      text: 'Веб-сервисы',
      icon: <WebIcon />,
      path: '/web-services'
    },
    {
      text: 'ТГ-сервисы',
      icon: <WebIcon />,
      path: '/tg-services'
    },
    {
      text: 'API Providers',
      icon: <ApiIcon />,
      path: '/api-providers'
    },
    {
      text: 'Ценообразование',
      icon: <CalculateIcon />,
      path: '/cost-reference'
    },
    {
      text: 'Закупочные цены ToAPIs',
      icon: <CalculateIcon />,
      path: '/toapis-purchase-prices'
    },
    {
      text: 'Закупочные цены Google',
      icon: <CalculateIcon />,
      path: '/google-purchase-prices'
    },
    {
      text: 'Закупочные цены KIE',
      icon: <CalculateIcon />,
      path: '/kie-purchase-prices'
    },
    {
      text: 'РКН',
      icon: <WarningAmberIcon />,
      path: '/rkn'
    },
    {
      text: 'Лимиты',
      icon: <CloudUploadIcon />,
      path: '/limits'
    },
    {
      text: 'API и MCP',
      icon: <SmartToyIcon />,
      path: '/mcp'
    },
    {
      text: 'Спец фичи',
      icon: <AutoAwesomeIcon />,
      path: '/special-features'
    },
    {
      text: 'Zavod',
      icon: <AutoAwesomeIcon />,
      path: '/zavod'
    },
    {
      text: 'GPU On Demand',
      icon: <CalculateIcon />,
      path: '/gpu-pricing'
    },
    {
      text: 'Кредитные пакеты',
      icon: <ShoppingCartIcon />,
      path: '/credit-packages'
    },
    {
      text: 'Юрлица',
      icon: <BusinessIcon />,
      path: '/legal-entities'
    },
    {
      text: 'Generation Results',
      icon: <MovieIcon />,
      path: '/generation-results'
    },
    {
      text: 'Lifecycle Monitoring',
      icon: <TimelineIcon />,
      path: '/lifecycle-monitoring'
    },
    {
      text: 'Видео: правила H.264',
      icon: <MovieIcon />,
      path: '/video-input-rules'
    },
    {
      text: 'Provider Alerts',
      icon: <WarningAmberIcon />,
      path: '/provider-alerts'
    },
    {
      text: 'User Management',
      icon: <PeopleIcon />,
      path: '/users'
    },
    {
      text: 'File Management',
      icon: <FolderIcon />,
      path: '/files'
    },
    {
      text: 'User Sessions',
      icon: <PersonIcon />,
      path: '/user-sessions'
    },
    {
      text: 'Parking Mode',
      icon: <BuildIcon />,
      path: '/parking'
    },
    {
      text: 'Storage',
      icon: <CloudIcon />,
      path: '/storage'
    },
    {
      text: 'Метеринг хранилища',
      icon: <CloudIcon />,
      path: '/storage-metering'
    },
    {
      text: 'Backups',
      icon: <BackupIcon />,
      path: '/backups'
    },
    {
      text: 'Новости',
      icon: <NewspaperIcon />,
      path: '/news'
    },
    {
      text: 'Подписки на постеры',
      icon: <CardMembershipIcon />,
      path: '/poster-subscriptions'
    },
    {
      text: 'Арбитраж',
      icon: <GavelIcon />,
      path: '/arbitration'
    },
    {
      text: 'Партнёрка',
      icon: <HandshakeIcon />,
      path: '/referral'
    },
    {
      text: 'Документы',
      icon: <DescriptionIcon />,
      path: '/legal-documents'
    },
    {
      text: 'Акты ПДн',
      icon: <GavelIcon />,
      path: '/pdn-acts'
    },
    {
      text: 'Settings',
      icon: <SettingsIcon />,
      path: '/settings'
    }
  ];

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMenuClick = (path: string) => {
    navigate(path);
    if (isMobile) {
      setMobileOpen(false);
    }
  };

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    try {
      await logout();
      handleProfileMenuClose();
    } catch {
      window.alert('Выход не завершён. Проверьте связь и нажмите «Выйти» ещё раз.');
    }
  };

  const drawer = (
    <Box>
      <Toolbar>
        <Typography variant="h6" noWrap component="div">
          AI Movie Bot
        </Typography>
      </Toolbar>
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              selected={location.pathname === item.path}
              onClick={() => handleMenuClick(item.path)}
              data-testid={item.text === 'API Providers' ? 'api-providers-menu' : undefined}
            >
              <ListItemIcon>
                {item.icon}
              </ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      {/* AppBar */}
      <AppBar
        position="fixed"
        sx={{
          width: { md: `calc(100% - ${drawerWidth}px)` },
          ml: { md: `${drawerWidth}px` },
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            Admin Panel
          </Typography>
          
          {/* Profile Menu */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Button
              color="inherit"
              onClick={handleProfileMenuOpen}
              startIcon={<Avatar sx={{ width: 32, height: 32 }}><AccountIcon /></Avatar>}
            >
              {user?.username || 'Admin'}
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleProfileMenuClose}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
              <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                  <LogoutIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Logout</ListItemText>
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Drawer */}
      <Box
        component="nav"
        sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}
      >
        {/* Mobile drawer */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', md: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
        
        {/* Desktop drawer */}
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', md: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>

      {/* Main content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { md: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
};

export default AdminLayout;